import { PathRouteContent, RouteNode } from 'router/declarative/routeNode';
import { AppModules } from '../../appContainer/types';

export const routes = {
  path: { layout: true },
  title: 'Presentations',
  children: [
    {
      path: '/presentation-admin',
      appModule: AppModules.PRESENTATIONS,
      content: async (): PathRouteContent =>
        (await import('./PresentationsContainer')).PresentationsContainer,
      children: [{ path: '/:presentationId', children: [{ path: '/open' }] }],
    },
  ],
} as const satisfies RouteNode;
